import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './index.scss';

function Cart({ data }) {
  const subTotal = parseFloat(data.amountTotal) - parseFloat(data.amountVat);
  const { t } = useTranslation();
  return (
    <div className="form-cart">
      <h3 className="form-cart__title">{t('subcribe_payment.cart')}</h3>
      <div className="form-cart__item">
        <p className="form-cart__item__label">{t('subcribe_payment.plan')}</p>
        <p className="form-cart__item__value">
          {t(`subscription_page.packages.${data.nameInEnglish}`)}
        </p>
      </div>
      <span className="form-cart__divide" />
      <div className="form-cart__item">
        <p className="form-cart__item__label">{t('subcribe_payment.type')}</p>
        <p className="form-cart__item__value">
          {t('common.transactions_table.btn_subscription')}
        </p>
      </div>
      <span className="form-cart__divide" />
      <div className="form-cart__item">
        <p className="form-cart__item__label">
          {t('subcribe_payment.number_of_message')}
        </p>
        <p className="form-cart__item__value">
          {data.creditNumber?.toLocaleString() || 0}
        </p>
      </div>
      <div className="form-cart__item">
        <p className="form-cart__item__label">{t('subcribe_payment.price')}</p>
        <p className="form-cart__item__value">
          ฿{parseFloat(data.price).toLocaleString() || 0}
        </p>
      </div>
      <span className="form-cart__divide --solid" />
      <div className="form-cart__item">
        <p className="form-cart__item__label">
          {t('subcribe_payment.subtotal')}
        </p>
        <p className="form-cart__item__value">฿{subTotal.toLocaleString()}</p>
      </div>
      <span className="form-cart__divide" />
      <div className="form-cart__item">
        <p className="form-cart__item__label">
          {t('subcribe_payment.vat_sevent_percent')}
        </p>
        <p className="form-cart__item__value">
          ฿{parseFloat(data.amountVat).toLocaleString() || 0}
        </p>
      </div>
      <span className="form-cart__divide" />
      <div className="form-cart__item">
        <p className="form-cart__item__label">{t('subcribe_payment.total')}</p>
        <p className="form-cart__item__value">
          ฿{parseFloat(data.amountTotal).toLocaleString() || 0}
        </p>
      </div>
    </div>
  );
}

Cart.propTypes = {
  data: PropTypes.object,
};

export default Cart;
